module.exports = __webpack_public_path__ + "static/media/blogexit2.dfe4e8d3.svg";